import PedidosCompraLista from "@/pages/pedidoscompra/PedidosCompraLista";
import PedidosCompraForm from "@/pages/pedidoscompra/PedidosCompraForm";

export default [
  {
    path: "/catalogo/pedidoscompra",
    name: "PedidosCompraLista",
    component: () => import(/* webpackChunkName: "PedidosCompraLista" */ '@/pages/pedidoscompra/PedidosCompraLista.vue'),
  },
  {
    path: "/catalogo/pedidoscompra/adicionar",
    name: "PedidosCompraAdicionar",
    component: () => import(/* webpackChunkName: "PedidosCompraForm" */ '@/pages/pedidoscompra/PedidosCompraForm.vue'),
  },
  {
    path: "/catalogo/pedidoscompra/:id/editar",
    name: "PedidosCompraEditar",
    component: () => import(/* webpackChunkName: "PedidosCompraForm" */ '@/pages/pedidoscompra/PedidosCompraForm.vue'),
  },
  {
    path: "/catalogo/pedidoscompra/:id/visualizar",
    name: "PedidosCompraVisualizar",
    component: () => import(/* webpackChunkName: "PedidosCompraForm" */ '@/pages/pedidoscompra/PedidosCompraForm.vue'),
  },

];
